import { User } from '../__generated__/graphql'

const isDevUser = (user: User): boolean => {
  return (
    user?.email?.endsWith('@worshiponline.com') ||
    user?.email?.endsWith('@shalonpalmer.tv')
  )
}

export const isLabEnabled = (user: User): boolean => {
  return (
    isDevUser(user) ||
    user?.features?.lab ||
    process.env.NEXT_PUBLIC_LAB_ENABLED === 'true'
  )
}

export default isDevUser
